import { render, staticRenderFns } from "./ChangeAudit.vue?vue&type=template&id=12c35f30&"
import script from "./ChangeAudit.vue?vue&type=script&lang=js&"
export * from "./ChangeAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports